export default __webpack_public_path__ + "static/media/search.57ee07e9.svg";